'use strict';
import $ from 'jquery';
import 'slick-carousel';

export default class LogoGarden {
    static init() {
        $('.logo-garden').each((index, el) => {
            new LogoGarden($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.logo-garden-logos').slick({
            mobileFirst: true,
            speed: 6000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            arrows: false,
            centerMode: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 8,
                    }
                }
            ]
        });
    }
}